export const LOAD_PURCHASE_REQUEST = "LOAD_PURCHASE_REQUEST";
export const LOAD_PURCHASE_SUCCESS = "LOAD_PURCHASE_SUCCESS";
export const LOAD_PURCHASE_FAIL = "LOAD_PURCHASE_FAIL";

export const ALL_PURCHASE_REQUEST = "ALL_PURCHASE_REQUEST";
export const ALL_PURCHASE_SUCCESS = "ALL_PURCHASE_SUCCESS";
export const ALL_PURCHASE_FAIL = "ALL_PURCHASE_FAIL";
